(function () {
    angular.module('invesfleet')
        .directive('zoomSrc',
        function ($document, $timeout) {
            /*USAGE:
            zoom-src="img" // When the element with this attribute is clicked it will open the img
            */

            return {
                restrict: 'A',
                scope:{
                    zoomSrc: '@'
                },
                link: function (scope, element, attrs) {

                    var body = $document.find('body')[0];
                    var overlay = angular.element('<div class="overlay animate roque"></div>');
                        //clone = element.clone(true);//.attr('src', attrs.large);
                    var clone = angular.element('<img src="' + scope.zoomSrc + '" class="zoom animate roque">');


                    scope.match = function (el, target) {
                        var rect = target[0].getBoundingClientRect();
                        el.css('height', rect.height + 'px');
                        el.css('left', rect.left + 'px');
                        el.css('top', rect.top + 'px');
                        el.css('width', rect.width + 'px');
                    };

                    scope.scaleDown = function (el) {
                        el.css('transform', 'scale(1) translateX(0px) translateY(0px)');
                    };

                    scope.scaleUp = function (el) {
                        var targetH = el[0].naturalHeight;
                        var targetW = el[0].naturalWidth;
                        var rect = el[0].getBoundingClientRect();

                        var maxH = window.innerHeight - 40;
                        var maxW = window.innerWidth - 40;

                        if(targetH > maxH){
                            targetH = maxH;
                            targetW = el[0].naturalWidth / el[0].naturalHeight * targetH;
                        }
                        
                        if(targetW > maxW){
                            targetW = maxW;
                            targetH = el[0].naturalHeight / el[0].naturalWidth * targetW;
                        }

                        var scaleW = (targetW / rect.width);
                        var scaleH = (targetH / rect.height);

                        var x = (((window.innerWidth / 2) - rect.left) / scaleW) - ((rect.width / 2));
                        var y = (((window.innerHeight / 2) - rect.top) / scaleH) - ((rect.height / 2));

                        el.css('transform',
                            'scale(' + scaleW + ',' + scaleH + ') translateX(' + x + 'px) translateY(' + y + 'px)');
                    };

                    overlay.append(clone);

                    overlay.bind('click', function () {
                        scope.match(clone, element);
                        overlay.removeClass('show');
                        scope.scaleDown(clone);
                        $timeout(function () {
                            body.removeChild(overlay[0]);
                        }, 500);
                    });

                    element.bind('click', function () {
                        scope.match(clone, element);
                        body.appendChild(overlay[0]);
                        $timeout(function () {
                            overlay.addClass('show');
                            scope.scaleUp(clone);
                        }, 10);
                    });
                }
            };
        });
}());